var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85986 2.57347L1.21319 12.0001C1.09677 12.2018 1.03517 12.4303 1.03452 12.6631C1.03387 12.896 1.09419 13.1249 1.20948 13.3272C1.32477 13.5294 1.49101 13.698 1.69167 13.816C1.89232 13.9341 2.12039 13.9976 2.35319 14.0001H13.6465C13.8793 13.9976 14.1074 13.9341 14.3081 13.816C14.5087 13.698 14.675 13.5294 14.7902 13.3272C14.9055 13.1249 14.9659 12.896 14.9652 12.6631C14.9646 12.4303 14.903 12.2018 14.7865 12.0001L9.13986 2.57347C9.02101 2.37754 8.85368 2.21555 8.65399 2.10313C8.45431 1.9907 8.22902 1.93164 7.99986 1.93164C7.7707 1.93164 7.54542 1.9907 7.34573 2.10313C7.14605 2.21555 6.97871 2.37754 6.85986 2.57347V2.57347Z",
    stroke: "#B3B8C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V9.33333",
    stroke: "#B3B8C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.334H8.00667",
    stroke: "#B3B8C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.179df301fdb797ea272ddeb7bbaac434.svg";
export { ForwardRef as ReactComponent };